import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCompanyStore = create(
  persist(
    (set, get) => ({
      companyId: null,
      company: null,
      companies: [],

      setCompanyId: companyId => set({ companyId }),

      setCompany: company => set({ company }),

      setCompanies: companies => set({ companies }),

      clearCompany: () => set({ companyId: null, company: null, companies: [] }),

      getCurrentCompany: () => {
        const { companyId, companies } = get();
        return companies.find(c => c.id === companyId) || null;
      },

      switchCompany: companyId => {
        const { companies } = get();
        const company = companies.find(c => c.id === companyId);
        if (company) {
          set({ companyId, company });
        }
      },
    }),
    {
      name: 'company-storage',
      partialize: state => ({ companyId: state.companyId }),
    },
  ),
);
